import Vue from "vue";
import VueRouter from "vue-router";
import Login from "@/components/Login.vue";
import Dashboard from "@/components/Dashboard.vue";
import About from "@/views/About.vue";

const Users = () => import("@/views/Users/User.vue");
const Roles = () => import("@/views/roles/roles.vue");
const Permisos = () => import("@/views/permisos/permisos.vue");

const Log = () => import("@/views/logs/log.vue");

const Initial = () => import("@/views/Initial.vue");
const UpdatePassword = () => import("@/components/UpdatePassword");
const Publicar = () => import("@/views/Publicar.vue");
const Reporte = () => import("@/views/Reporte.vue");
const GetFile = () => import("@/views/GetFile.vue");
const NotFound = () => import("@/views/NotFound.vue");
const Estadisticas = () => import("@/views/Estadisticas.vue");
const Juzgados = () => import("@/views/juzgados/juzgados.vue");
const Municipios = () => import("@/views/municipios/municipios.vue");

Vue.use(VueRouter);

const routes = [
  /*{
    path: "/",
    name: "Initial",
    component: Initial,
  },*/
  {
    path: "/",
    name: "Publicar",
    component: Publicar,
  },

  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/edictos",
    name: "Publicar",
    component: Publicar,
  },
  /*{
    path: "/reporte",
    name: "Reporte",
    component: Reporte,
    meta: { authorize: ['superadmin', 'admin'] }
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },*/
  {
    path: "/users",
    name: "Users",
    component: Users,
    meta: { authorize: ['superadmin'] }
  },
  {
    path: "/juzgados",
    name: "Juzgados",
    component: Juzgados,
    meta: { authorize: ['superadmin'] }
  },
  {
    path: "/municipios",
    name: "Municipios",
    component: Municipios,
    meta: { authorize: ['superadmin'] }
  },
  {
    path: "/roles",
    name: "Roles",
    component: Roles,
    meta: { authorize: ['superadmin'] }
  },
  /*{
    path: "/permisos",
    name: "Permisos",
    component: Permisos,
    meta: { authorize: ['superadmin'] }
  },
  {
    path: "/updatepassword",
    name: "UpdatePassword",
    component: UpdatePassword,
    meta: { authorize: ['superadmin', 'admin', 'enlace'] }
  },*/
  {
    path: "/getfile/:id",
    name: "GetFile",
    component: GetFile,
    props: true,
  },
  {
    path :'*',
    component:NotFound
  },
  /*{
    path: "/estadisticas",
    name: "Estadisticas",
    component: Estadisticas,
    meta: { authorize: ['superadmin', 'admin'] }
  },*/
];

const router = new VueRouter({
  mode: "history",
  routes
});

router.beforeEach((to, from, next) => {
  const { authorize } = to.meta;
  const userLogged = JSON.parse(localStorage.getItem("user"));

  if (authorize) {
    //si si tiene restricciones la ruta
    if (!userLogged) {
      //y no esta logeado entonces a logear
      return next({
        path: "/"
      });
    }
    //checar si la routa esta restringida por algun role_id y  NO coincide el role_id del user logeado
    if (authorize.length && !authorize.includes(userLogged.roles[0].name)) {
      return next({ path: "/" });
    }
  }
  if ( (to.path === "/login") && userLogged ) {
    return next({ path: "/edictos" });
  }
  next();
});

export default router;
